import autobind from 'class-autobind';
import BaseComponent from '../App/base';
import * as actions from '../../actions/TrialActions';
import './index.scss';
import API from '../../api';

export default class Trial extends BaseComponent {
  constructor(selector, store) {
    super(selector, store, 'trial');

    window.trialActions = actions;

    this.$trialDaysArea = $(selector);
    autobind(this);
  }

  renewSession() {
    API.renew_session().then((data) => {
      stripe
        .redirectToCheckout({
          sessionId: data.session_id,
        })
        .then((result) => {
          // $form.find("button").removeAttr("disabled");
        });
    });
  }

  div() {
    const day_word = this.state.trial.days_left == 1 ? 'day' : 'days';
    if (this.state.trial.days_left > 0) {
      return `<a href='#' onclick="window.store.dispatch(
      window.trialActions.renewSession()
    )" class='content days${this.state.trial.days_left}'>${this.state.trial.days_left} ${day_word} left on your free trial. Upgrade →</a>`;
    }

    return `<a href='#' onclick="window.store.dispatch(
          window.trialActions.renewSession()
        )" class='content'>Your free trial expires today. Upgrade →</a>`;
  }

  overlay() {
    return `<div class="trial-overlay"></div><a href='#' onclick="window.store.dispatch(
      window.trialActions.renewSession()
    )" class='content'>Your free trial has ended. Upgrade →</a>`;
  }

  render() {

    if (this.state.trial.showTrialDays) {
      this.$trialDaysArea.html(this.div());
    } else {
      this.$trialDaysArea.html('');
    }

    if (this.state.trial.expired) {
      this.$trialDaysArea.html(this.overlay());
    }

    if (this.state.trial.renewSession) {
      this.renewSession();
    }
  }
}
